import externalRouter from 'src/utils/externalRouter';
import appConfig from 'src/utils/appConfig';
import { getReturnToURLFromParams } from 'src/router/queryString';

/*
 * getOauthUrl() provides method for handling Oauth registration
 */

export default (provider) => {
  const oauthParams = Object.assign({
    provider
  }, appConfig.serialize());

  const returnToURL = getReturnToURLFromParams();
  if (returnToURL) oauthParams.return_to = encodeURIComponent(returnToURL);

  return externalRouter.parse('oauthUserRegistration', oauthParams);
};
